const RegulationTypeEnum = Object.assign({
  Mifid2: 'mifid2',
  Ecsp: 'ecsp',
  VermAnl: 'VermAnl',
});

Object.freeze(RegulationTypeEnum);

export default RegulationTypeEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/RegulationType.js